// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__ZPi1x","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__24aG6"};